import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import useAuth from '../../providers/authProvider';
import useCookies from '../../hooks/useCookies';

function RepresentativeLogin() {
  const [values, setValues] = useState({ email: '', password: '' });
  const [errors, setErrors] = useState({});
  const [rememberMe, setRememberMe] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const { setCookie, getCookie, deleteCookie } = useCookies();
  const { message, login, successmessage } = useAuth();

  const validateForm = () => {
    let validationErrors = {};

    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!values.email.trim()) {
      validationErrors.email = 'Email is required';
    } else if (!emailRegex.test(values.email.trim())) {
      validationErrors.email = 'Enter a valid email address';
    }

    if (!values.password.trim()) {
      validationErrors.password = 'Password is required';
    }

    return validationErrors;
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setValues((prevValues) => ({ ...prevValues, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    const response = await login(values.email, values.password, rememberMe);
    setLoading(false);

    if (response && response?.token) {

      localStorage.removeItem("token");
      sessionStorage.removeItem("token");

      localStorage.setItem("token", response.token);

      if (rememberMe) {
        setCookie("email", values.email, 7);
        setCookie("rememberMe", "true", 7);
        setCookie("token", response.token, 7);
      } else {
        deleteCookie("email");
        deleteCookie("rememberMe");
        deleteCookie("token");

      }
      window.dispatchEvent(new Event("authChange"));

      window.location.href = "/dashboard";
    }
  };

  useEffect(() => {
    const storedEmail = getCookie('email');
    const storedRememberMe = getCookie('rememberMe') === 'true';

    if (storedRememberMe && storedEmail) {
      setValues((prevValues) => ({ ...prevValues, email: storedEmail }));
      setRememberMe(true);
    }
  }, []);

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleSubmit(event);
    }
  };

  useEffect(() => {
    if (message && message.message) {
      toast.error(message.message);
    }
  }, [message]);

  useEffect(() => {
    if (successmessage && successmessage.successmessage) {
      toast.success(successmessage.successmessage);
    }
  }, [successmessage]);

  return (
    <div>
      <ToastContainer position="top-right" autoClose={10000} theme="colored" />
      <form onSubmit={handleSubmit}>
        <div>
          <label htmlFor="email">User Name</label>
          <input
            className="form-control"
            type="text"
            name="email"
            id="email"
            placeholder="Enter Your Email"
            value={values.email}
            onChange={handleInputChange}
            onKeyDown={handleKeyPress}
          />
          {errors.email && <div style={{ color: 'red' }}>{errors.email}</div>}

          <label className="mt-3" htmlFor="password">Password</label>
          <div className="input-group">
            <input
              className="form-control"
              type="password"
              name="password"
              id="password"
              placeholder="Enter Your Password"
              value={values.password}
              onChange={handleInputChange}
              onKeyDown={handleKeyPress}
            />
            <div className="input-group-append">
              <button className="btn fa field-icon fa-eye-slash" id="eye" type="button"></button>
            </div>
          </div>
          {errors.password && <div style={{ color: 'red' }}>{errors.password}</div>}

          <div className="d-flex justify-content-between align-items-center w-100">
            <div className="form-group mt-2">
              <input
                type="checkbox"
                id="rememberMe"
                name="rememberMe"
                checked={rememberMe ? true : false}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <label htmlFor="rememberMe">Keep me signed in</label>
            </div>
          </div>
          <div className="d-flex justify-content-between align-items-end">
            <div>
              <Link to="/forgot-password">
                <button className="btn forgot-password-btn">Forgot password?</button>
              </Link>
            </div>
            <div className="text-center">
              <button className="btn login-btn mt-2" type="submit">
                {loading ? 'Loading...' : 'Login'}
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default RepresentativeLogin;
